<template>
    <section class="profile">
      <div class="wrap" v-if="user && !loader">

        <Statistic :statistic="user.statistic" />

        <div class="profile-fixed">
          <Card 
            :user="user" 
            :itsYou="itsYou" 
            @setChoise="choise = true"
            @setEditor="editor = true"
            @setSports="sports = true"
            @setRate="rate = true"
          />
        </div>

        <div class="profile-body" v-if="user.profile && !user.profile.deleted">

          <Friends :friends="user.profile.friends" />

          <!-- About -->
          <TextareaAutosize
            class="profile-about_textarea"
            v-model="user.profile.about"
            :placeholder="'Напишите пару строк о себе'"
            ref="aboutText"
            v-if="itsYou"
          />

          <p class="profile-about" v-else >{{ user.profile.about  }}</p>

          <Photos :photos="user.photos" :itsYou="itsYou" />

          <Events :events="user.events" :itsYou="itsYou" :user="user.profile" />

          <Places :places="user.places" :itsYou="itsYou" :user="user.profile" />

          <div class="profile-pins" v-if="pins && pins.length > 0">
            <Pins :pins="pins" :adder="itsYou"/>
          </div>

        </div>
      </div>

      <Loader v-else />

      <!-- Other -->
      <SportsWindow 
        v-if="sports" 
        :actives="getActiveSports" 
        @closeSports="closeSports($event)" 
        @changeSports="changeSports($event)" />
      
      <ModalPhotos />
      
      <Editor 
        v-if="editor" 
        :user="user" 
        @close="editor = false" 
      />
      
      <Choise 
        v-if="choise" 
        :variables="getChoise" 
        @close="choise = null" 
        @choise="choiseHandler"
      />
      
      <Complain 
        v-if="complain"
        :settings="complain"
        @click="complain = false"
        @close="complain = false" 
      />
        
      <Rate 
        v-if="user && user.profile.score && rate" 
        :score="user.profile.score"
        :itsYou="itsYou"
        @close="rate = false"
      />
    </section>
</template>
<script>
export default {
  name: "Profile",
  data: () => {
    return {
      sports: false,
      editor: false,
      pins_page: 0,
      user: null,
      choise: null,
      complain: null,
      loader: false,
      rate: false
    }
  },
  components: {
    ModalPhotos: () => import("@/components/Modals/ModalPhoto"),
    SportsWindow: () => import("@/components/Filters/SportsWindowProfile"),
    Editor: () => import("@/components/Profile/Editor"),
    Pins: () => import("@/components/Lenta/Pins"),
    Choise: () => import("@/components/Modals/Choise"),
    Complain: () => import('@/components/Lenta/Complain.vue'),
    Statistic: () => import('./components/Statistic'),
    Card: () => import('./components/Card'),
    Friends: () => import('./components/Friends'),
    Photos: () => import('./components/Photos'),
    Places: () => import('./components/Places'),
    Events: () => import('./components/Events'),
    Loader: () => import('./components/Loader'),
    Rate: () => import('./components/Rate'),
  },
  computed: {
    // ...mapState({
    //     user: state => state.profile.user
    // }),
    pins () {
      return this.$store.getters.getPins
    },
    getChoise() {
      return [
        {
          name: 'complain',
          warning: true,
          title: 'Пожаловаться'
        },
        {
          name: 'block',
          warning: true,
          title: this.inBlackList ? 'Разблокировать' : 'Заблокировать'
        },
      ]
    },
    getUser () {
      return this.$store.getters.getAuthUser
    },
    itsYou() {
      return this.getUser ? this.user.profile.id == this.getUser.id ? true : false : false
    },
    getActiveSports () {
      return this.user && this.user.profile && this.user.profile.sports ? this.user.profile.sports : []
    },
    inBlackList () {
      return this.getUser && this.user.profile.id ? this.getUser.blacklist.find(blocked => blocked.blocked_id === this.user.profile.id) : false
    },
    blockedYou () {
      return this.getUser && this.user.profile.blacklist ? this.user.blacklist.find(blocked => blocked.blocked_id === this.getUser.id) : false
    }
  },
  methods: {
    choiseHandler(val) {
      if (val && val.name) {
        switch (val.name) {
          case 'complain':
            this.complain = {
              type: 'user',
              user: this.user.profile
            }
            break;
          case 'block':
            this.blockUser()
            break;
        }
      }
    },
    blockUser () {
      this.$axios.post('/api/account/blacklist', {
          blocked_id: this.user.profile.id
      })
      .then(() => {
        this.$store.dispatch('getAuthUser')
      })
    },
    
    closeSports(save) {
      this.sports = false
      if (save) {
        this.$store.dispatch('changeProfileSports', {sports: this.user.profile.sports, user: this.user.profile.id })
        .then(() => {
          this.$store.dispatch('addNotification', {message: 'Ваши категории спортов изменены'});
        }).catch(e => {e
          this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
        });
      }
    },
    changeSports (element) {
      let finded = this.user.profile.sports.find(sport => sport.id === element.id);
      finded ? this.user.profile.sports.splice(this.user.profile.sports.indexOf(finded), 1)  : this.user.profile.sports.push(element);
    },
    
    async changeName(type, val) {
      let value = val.target.value;
      value = type === 'nickname' ? value.split('@').join('') : value;
      let messages = {
        lastname: 'Ваша фамилия обновлена',
        firstname: 'Ваше имя обновлено',
        about: 'Информация о вас была обновлена',
        nickname: 'Ваш никнэйм был обновлён'
      };
      await this.$store.dispatch('editUser', {options: {type: type, value }, user: this.getUser.id})
        .then(() => {
          messages[type] ? this.$store.dispatch('addNotification', {message: messages[type]}) : '';
        })
        .catch(() =>{
          this.$store.dispatch('addError', {message: 'Что-то пошло не так'})
        });
    },
    
    
    async loadPins() {
      await this.$store.dispatch('getPins', {limit: 10, page: this.pins_page, user: this.$route.params.id});
    },
    async loadMorePins() {
      this.pins_page++
      await this.$store.dispatch('getPins', {limit: 10, page: this.pins_page, more: true})
    },
    lazyLoad() {
      this.pins_window.scrollTop = this.pins_window.scrollHeight;
      let timeout = false;
      this.pins_window.onscroll = () => {
        if (timeout !== false) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(async () => {
          this.pins_position = this.pins_window.scrollHeight - (this.pins_window.scrollTop + this.pins_window.clientHeight);
            if (this.pins_position < 600) {
              this.page++
              this.loadMore()
            } 
        }, 300);
      }
    },
    scrollHandler() {
      // TODO: переписать
      this.pins_window = document.querySelector(".pins");
      if (this.pins_window) {
        this.lazyLoad()
      } else {
        setTimeout(() => {
          this.pins_window = document.querySelector(".pins");
          this.lazyLoad()
        }, 400)
        if (!this.pins_window) {
          setTimeout(() => {
            this.pins_window = document.querySelector(".pins");
            this.lazyLoad()
          }, 400)
        }
      }      
    },
    async loadData() {
      this.loader = true
      this.user = await this.$store.dispatch("getUser", {
        user: this.$route.params.id
      });
      console.log(this.user);
      this.loader = false
    }
  },
  watch: {
    async $route(to) {
      this.user = await this.$store.dispatch("getUser", {
        user: to.params.id
      });
      this.loadPins()
      this.user.profile 
        ? setTimeout(() => {
          if (this.$refs['aboutText']) {
            this.$refs['aboutText'].$el.addEventListener('change', (ev) => {
              this.changeName('about', ev)
            })
          }
        }, 50) : ''; 
      this.user ? 'WildWood — ' + this.user.profile.firstname + ' ' + this.user.profile.lastname : this.$router.push({name: '404'}); 
    }
    
  },
  async mounted() {
    await this.loadData()
    await this.loadPins()
    this.scrollHandler()
    this.user
        ? 'WildWood — ' + this.user.profile.firstname + ' ' + this.user.profile.lastname 
        : this.$router.push({name: '404'}); 
  },
};
</script>